<template>
  <div class="column content-box">
    <div class="small-12 columns integrations-wrap">
      <div class="small-12 columns integration">
        <div class="row">
          <div class="integration--image">
            <img :src="'/dashboard/images/integrations/' + integration.logo" />
          </div>
          <div class="integration--type column">
            <h3 class="integration--title">
              {{ integration.name }}
            </h3>
            <p>
              {{ integration.description }}
            </p>
          </div>
          <div class="small-2 column button-wrap">
            <div v-if="hasConnectedHooks">
              <div @click="$emit('delete', integration.hooks[0])">
                <woot-button class="nice alert">
                  {{ $t('INTEGRATION_APPS.DISCONNECT.BUTTON_TEXT') }}
                </woot-button>
              </div>
            </div>
            <div v-else>
              <woot-button class="button nice" @click="$emit('add')">
                {{ $t('INTEGRATION_APPS.CONNECT.BUTTON_TEXT') }}
              </woot-button>
            </div>
          </div>
        </div>

        <Quotation v-if="hasQuotation" :integration="integration" />

        <UpdateAvatar v-if="hasUpdateAvatar" :integration="integration" />
      </div>
    </div>
  </div>
</template>
<script>
import hookMixin from './hookMixin';
import Quotation from './quotation/Quotation.vue';
import UpdateAvatar from './UpdateAvatar/UpdateAvatar.vue';

export default {
  components: {
    Quotation,
    UpdateAvatar,
  },
  mixins: [hookMixin],
  props: {
    integration: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    hasQuotation() {
      if (!this.integration.hooks.length) return false;
      const { client_id } = this.integration.hooks[0].settings;
      return this.integration.id === 'quotation' && client_id;
    },
    hasUpdateAvatar() {
      if (!this.integration.hooks?.length) return false;
      return this.integration.id === 'update_avatar';
    },
  },
};
</script>
